import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'
import store from '@/store/store'

const DIR = 'erp/invoices'
const DEFAULT_INVOICE = {
    "id": 0,
    "alvId": "ALV000000000IN",
    "arrivalConfirmation" : null,
    "conversionFactor" : null,
    "currency": null,
    "date" : null,
    "dueDate" : null,
    "invoiceRows" : [],
    "language" : "de",
    "note" : null,
    "number" : null,
    "paidDate" : null,
    "partialPayment" : null,
    "paymentMethod" : null,
    "paymentMethodDetails" : null,
    "term" : null,
    "periodOfService" : null,
    "recipient" : null,
    "recipientFullAddress" : null,
    "salesType" : null,
    "statisticIn" : null,
    "status" : null,
    "type" : null,
    "vatId" : null,
    "transactionNumber":null,
    "linkedDocument": null,
    "settleIn": {
        "num": null,
        "period": null,
        "year": null
    }, // period can be null, not "offen" or "notDefined",
}

const DEFAULT_INVOICEROWS = {
    "id": 0,
    "alvId": "ALV000000000IR",
    "connectionId": null,
    "currency": null,  // TODO_PT: no need for that, currency set at invoice level
    "title": { "title": null },
    "batch": null,
    "price": null,
    "productId": null,
    "quantity": null,
    "sum": null,
    "type": null,
    "vat": null,
}

const state = {
    invoices: [],
    selectedInvoices: [],
    isAllSelectedInvoices: false,

    // Filter
    invoicesSearch: '',
    selectedInvoicesStatusFilter: [],
    selectedInvoicesTypeFilter: [],
    selectedInvoicesPeriodFromFilter: null,
    selectedInvoicesPeriodToFilter: null,
    selectedInvoicesPeriodDateFilter: 'invoicesDate',
    
    // Sorting
    invoicesServerSideSortingOptions: {
        sortBy: ['date'],
        sortDesc: [true],
        mustSort: true
    },

    // Actions
    selectedInvoicesAction: [],

    // Details
    defaultNewInvoice: DEFAULT_INVOICE,
    invoicesUniqueId: '',
    expandedInvoices: [],
    invoicesDetails: DEFAULT_INVOICE,
    invoicesRecipientOptions: [],

    // Edit Form
    selectedInvoiceId: null,
    statisticIn: null,
    settleIn: {
        num: null,
        period: null,
        year: null
    },

    // Panel: InvoiceRows
    invoicesInvoiceRows: [],
    selectedInvoicesInvoiceRows: [],

    // Editing Dialog: InvoiceRows
    defaultInvoicesInvoiceRows: DEFAULT_INVOICEROWS,
    invoicesInvoiceRowsEditingDialogDetails: DEFAULT_INVOICEROWS,
    invoicesInvoiceRowsTitleOptions: [],
    invoicesInvoiceRowsTitleSearch: null,
    invoicesInvoiceRowsIsNewSearch: null,
}

const getters = {

    // Invoices List Page
    getInvoices                                 (state) { return state.invoices },
    getSelectedInvoices                         (state) { return state.selectedInvoices },
    getIsAllSelectedInvoices                    (state) { return state.isAllSelectedInvoices },

    // Filters & Actions & Buttons
    getInvoicesSearch                           (state) { return state.invoicesSearch },
    getSelectedInvoicesStatusFilter             (state) { return state.selectedInvoicesStatusFilter },
    getSelectedInvoicesTypeFilter               (state) { return state.selectedInvoicesTypeFilter },
    getSelectedInvoicesPeriodFromFilter         (state) { return state.selectedInvoicesPeriodFromFilter },
    getSelectedInvoicesPeriodToFilter           (state) { return state.selectedInvoicesPeriodToFilter },
    getSelectedInvoicesPeriodDateFilter         (state) { return state.selectedInvoicesPeriodDateFilter },
    getSelectedInvoicesAction                   (state) { return state.selectedInvoicesAction },

    //Sorting
    getInvoicesServerSideSortingOptions         (state) { return state.invoicesServerSideSortingOptions},

    // Details
    getDefaultNewInvoice                        (state) { return state.defaultNewInvoice },
    getInvoiceUniqueId                          (state) { return state.invoiceUniqueId },
    getExpandedInvoices                         (state) { return state.expandedInvoices },
    getInvoicesDetails                          (state) { return state.invoicesDetails },
    getInvoicesDetailsAlvId                     (state) { return state.invoicesDetails.alvId },

    getInvoicesRecipientOptions                 (state) { return state.invoicesRecipientOptions },

    getInvoicesDetailsArrivalConfirmation       (state) { return state.invoicesDetails.arrivalConfirmation },
    getInvoicesDetailsConversionFactor          (state) { return state.invoicesDetails.conversionFactor },
    getInvoicesDetailsCurrency                  (state) { return state.invoicesDetails.currency },
    getInvoicesDetailsDate                      (state) { return state.invoicesDetails.date },
    getInvoicesDetailsDueDate                   (state) { return state.invoicesDetails.dueDate },
    getInvoicesDetailsNote                      (state) { return state.invoicesDetails.note },
    getInvoicesDetailsNumber                    (state) { return state.invoicesDetails.number },
    getInvoicesDetailsPaidDate                  (state) { return state.invoicesDetails.paidDate },
    getInvoicesDetailsPartialPayment            (state) { return state.invoicesDetails.partialPayment },
    getInvoicesDetailsPaymentMethod             (state) { return state.invoicesDetails.paymentMethod },
    getInvoicesDetailsPaymentMethodDetails      (state) { return state.invoicesDetails.paymentMethodDetails },
    getInvoicesDetailsPeriodOfService           (state) { return state.invoicesDetails.periodOfService },
    getInvoicesDetailsRecipient                 (state) { return state.invoicesDetails.recipient },
    getInvoicesDetailsRecipientFullAddress      (state) { return state.invoicesDetails.recipientFullAddress },
    getInvoicesDetailsLanguage                  (state) { return state.invoicesDetails.language },
    getInvoicesDetailsSalesType                 (state) { return state.invoicesDetails.salesType },
    getInvoicesDetailsStatisticIn               (state) { return state.invoicesDetails.statisticIn },
    getInvoicesDetailsSettleInPeriod            (state) { return state.invoicesDetails.settleIn },
    getInvoicesDetailsStatus                    (state) { return state.invoicesDetails.status },
    getInvoicesDetailsTerm                      (state) { return state.invoicesDetails.term },
    getInvoicesDetailsType                      (state) { return state.invoicesDetails.type },
    getInvoicesDetailsVatId                     (state) { return state.invoicesDetails.vatId },
    getInvoicesDetailsTransactionNumber         (state) { return state.invoicesDetails.transactionNumber },
    getInvoicesDetailsLinkedDocument            (state) { return state.invoicesDetails.linkedDocument },

    // due presumably to timing issues, we need to check for the existence of the settleIn attribute
    getSelectedPeriodNumberInvoices (state) {
        if (state.invoicesDetails.settleIn !== undefined){
            return state.invoicesDetails.settleIn.num
        } else {
            return null
        }
    },
    getSelectedPeriodTimeUnitInvoices (state) {
        if (state.invoicesDetails.settleIn !== undefined){
            return state.invoicesDetails.settleIn.period
        } else {
            return null
        }
    },
    getSelectedPeriodYearInvoices (state) {
        if (state.invoicesDetails.settleIn !== undefined){
            return state.invoicesDetails.settleIn.year
        } else {
            return null
        }
    },

    // Panel: InvoiceRows (without "s")
    getInvoicesInvoiceRows                      (state) { return state.invoicesInvoiceRows },
    getSelectedInvoicesInvoiceRows              (state) { return state.selectedInvoicesInvoiceRows },

    // Editing Dialog: InvoiceRows
    getDefaultInvoicesInvoiceRows               (state) { return state.defaultInvoicesInvoiceRows },
    getInvoicesInvoiceRowsEditingDialogDetails  (state) { return state.invoicesInvoiceRowsEditingDialogDetails },

    getInvoicesInvoiceRowsDetailsAlvId          (state) { return state.invoicesInvoiceRowsEditingDialogDetails.alvId },
    getInvoicesInvoiceRowsDetailsBatch          (state) { return state.invoicesInvoiceRowsEditingDialogDetails.batch },
    getInvoicesInvoiceRowsDetailsConnectionId   (state) { return state.invoicesInvoiceRowsEditingDialogDetails.connectionId },
    getInvoicesInvoiceRowsDetailsPrice          (state) { return state.invoicesInvoiceRowsEditingDialogDetails.price },
    getInvoicesInvoiceRowsDetailsProductId      (state) { return state.invoicesInvoiceRowsEditingDialogDetails.productId },
    getInvoicesInvoiceRowsDetailsQuantity       (state) { return state.invoicesInvoiceRowsEditingDialogDetails.quantity },
    getInvoicesInvoiceRowsDetailsSum            (state) { return state.invoicesInvoiceRowsEditingDialogDetails.sum },
    getInvoicesInvoiceRowsDetailsTitle          (state) { return state.invoicesInvoiceRowsEditingDialogDetails.title },
    getInvoicesInvoiceRowsDetailsTitleReadOnly  (state) {
        if(typeof state.invoicesInvoiceRowsEditingDialogDetails.title === "string") return state.invoicesInvoiceRowsEditingDialogDetails.title
        else return state.invoicesInvoiceRowsEditingDialogDetails.title.title
    },
    // type is an additional attribute to store the searchType for each row, especially new rows
    getInvoicesInvoiceRowsDetailsType           (state) { return state.invoicesInvoiceRowsEditingDialogDetails.type },
    getInvoicesInvoiceRowsDetailsVat            (state) { return state.invoicesInvoiceRowsEditingDialogDetails.vat },

    getInvoicesInvoiceRowsTitleOptions          (state) { return state.invoicesInvoiceRowsTitleOptions },
    getInvoicesInvoiceRowsTitleSearch           (state) { return state.invoicesInvoiceRowsTitleSearch },
    getInvoicesInvoiceRowsIsNewSearch           (state) { return state.invoicesInvoiceRowsIsNewSearch },
}

const mutations = {

    // Invoices List Page
    setInvoices:                                (state, invoices) => { state.invoices = invoices },
    setSelectedInvoices:                        (state, selected) => { state.selectedInvoices = selected },
    setIsAllSelectedInvoices:                   (state, isSelected) => { state.isAllSelectedInvoices = isSelected },

    // Filters & Actions & Buttons
    setInvoicesSearch:                          (state, search) => { state.invoicesSearch = search },
    setSelectedInvoicesStatusFilter:            (state, selected) => { state.selectedInvoicesStatusFilter = selected },
    setSelectedInvoicesTypeFilter:              (state, selected) => { state.selectedInvoicesTypeFilter = selected },
    setSelectedInvoicesPeriodFromFilter:        (state, selected) => { state.selectedInvoicesPeriodFromFilter = selected },
    setSelectedInvoicesPeriodToFilter:          (state, selected) => { state.selectedInvoicesPeriodToFilter = selected },
    setSelectedInvoicesPeriodDateFilter:        (state, selected) => { state.selectedInvoicesPeriodDateFilter = selected },
    setSelectedInvoicesAction:                  (state, action) => { state.selectedInvoicesAction = action },

    //Sorting
    setInvoicesServerSideSortingOptions:        (state, value)    => {state.invoicesServerSideSortingOptions = value},

    // Details
    setDefaultNewInvoice:                       (state)         => { state.defaultNewInvoice = DEFAULT_INVOICE },
    setInvoicesUniqueId:                        (state, id)     => { state.invoiceUniqueId = id },
    setExpandedInvoices:                        (state, item)   => {
                                                    if (Object.keys(item).length === 0) state.expandedInvoices = []
                                                    else state.expandedInvoices.push(item)
                                                },
    setInvoicesRecipientOptions:                (state, items)  => { state.invoicesRecipientOptions = items },
    setInvoicesDetails:                         (state, details)=> { state.invoicesDetails = details },
    setInvoicesDetailsAlvId:                    (state, alvId)  => { state.invoicesDetails.alvId = alvId },
    setInvoicesDetailsArrivalConfirmation:      (state, yesno)  => { state.invoicesDetails.arrivalConfirmation = yesno },
    setInvoicesDetailsConversionFactor:         (state, item)   => { state.invoicesDetails.conversionFactor = item },
    setInvoicesDetailsCurrency:                 (state, item)   => { state.invoicesDetails.currency = item },
    setInvoicesDetailsDate:                     (state, item)   => { state.invoicesDetails.date = item },
    setInvoicesDetailsDueDate:                  (state, item)   => { state.invoicesDetails.dueDate = item },
    setInvoicesDetailsNote:                     (state, item)   => { state.invoicesDetails.note = item },
    setInvoicesDetailsNumber:                   (state, number) => { state.invoicesDetails.number = number },
    setInvoicesDetailsPaidDate:                 (state, item)   => { state.invoicesDetails.paidDate = item },
    setInvoicesDetailsPartialPayment:           (state, item)   => { state.invoicesDetails.partialPayment = item },
    setInvoicesDetailsPaymentMethod:            (state, item)   => { state.invoicesDetails.paymentMethod = item },
    setInvoicesDetailsPaymentMethodDetails:     (state, item)   => { state.invoicesDetails.paymentMethodDetails = item },
    setInvoicesDetailsPeriodOfService:          (state, item)   => { state.invoicesDetails.periodOfService = item },
    setInvoicesDetailsRecipient:                (state, item)   => { state.invoicesDetails.recipient = item },
    setInvoicesDetailsRecipientFullAddress:     (state, address)=> { state.invoicesDetails.recipientFullAddress = address },
    setInvoicesDetailsLanguage:                 (state, item)   => { state.invoicesDetails.language = item },
    setInvoicesDetailsSalesType:                (state, type)   => { state.invoicesDetails.salesType = type },
    setInvoicesDetailsStatisticIn:              (state, item)   => { state.invoicesDetails.statisticIn = item },
    setInvoicesDetailsSettleInPeriod:           (state, item)   => { state.invoicesDetails.settleIn = item },
    setInvoicesDetailsStatus:                   (state, status) => { state.invoicesDetails.status = status },
    setInvoicesDetailsTerm:                     (state, item)   => { state.invoicesDetails.term = item },
    setInvoicesDetailsType:                     (state, type)   => { state.invoicesDetails.type = type },
    setInvoicesDetailsVatId:                    (state, item)   => { state.invoicesDetails.vatId = item },

    // Account in period
    setSelectedPeriodNumberInvoices:            (state, num) => { state.invoicesDetails.settleIn.num = num },
    setSelectedPeriodTimeUnitInvoices:          (state, period) => { state.invoicesDetails.settleIn.period = period },
    setSelectedPeriodYearInvoices:              (state, year) => { state.invoicesDetails.settleIn.year = year },

    // Panel: InvoiceRows
    setInvoicesInvoiceRows:                     (state, rows)       => { state.invoicesInvoiceRows = rows },
    setSelectedInvoicesInvoiceRows:             (state, rows)       => { state.selectedInvoicesInvoiceRows = rows },

    // Editing Dialog: InvoiceRows
    setDefaultInvoicesInvoiceRows:              (state)             => { state.defaultInvoicesInvoiceRows = DEFAULT_INVOICEROWS },
    setInvoicesInvoiceRowsEditingDialogDetails: (state, details)    => { state.invoicesInvoiceRowsEditingDialogDetails = details },

    setInvoicesInvoiceRowsDetailsAlvId:         (state, alvId)      => { state.invoicesInvoiceRowsEditingDialogDetails.alvId = alvId },
    setInvoicesInvoiceRowsDetailsBatch:         (state, batch)      => { state.invoicesInvoiceRowsEditingDialogDetails.batch = batch },
    setInvoicesInvoiceRowsDetailsConnectionId:  (state, id)         => { state.invoicesInvoiceRowsEditingDialogDetails.connectionId = id },
    setInvoicesInvoiceRowsDetailsPrice:         (state, price)      => { state.invoicesInvoiceRowsEditingDialogDetails.price = price },
    setInvoicesInvoiceRowsDetailsProductId:     (state, id)         => { state.invoicesInvoiceRowsEditingDialogDetails.productId = id },
    setInvoicesInvoiceRowsDetailsQuantity:      (state, quantity)   => { state.invoicesInvoiceRowsEditingDialogDetails.quantity = quantity },
    setInvoicesInvoiceRowsDetailsSum:           (state, sum)        => { state.invoicesInvoiceRowsEditingDialogDetails.sum = sum },
    setInvoicesInvoiceRowsDetailsTitle:         (state, title)      => { state.invoicesInvoiceRowsEditingDialogDetails.title = title },
    // type is an additional attribute to store the searchType of a new row
    setInvoicesInvoiceRowsDetailsType:          (state, type)       => { state.invoicesInvoiceRowsEditingDialogDetails.type = type },
    setInvoicesInvoiceRowsDetailsVat:           (state, vat)        => { state.invoicesInvoiceRowsEditingDialogDetails.vat = vat },

    setInvoicesInvoiceRowsTitleOptions:         (state, options)    => { state.invoicesInvoiceRowsTitleOptions = options },
    setInvoicesInvoiceRowsTitleSearch:          (state, search)     => { state.invoicesInvoiceRowsTitleSearch = search },
    setInvoicesInvoiceRowsIsNewSearch:          (state, flag)       => { state.invoicesInvoiceRowsIsNewSearch = flag },

}

const actions = {

    // FETCH
    async fetchInvoices({ commit, getters }) {

        commit('setIsLoading', true)

        // check for set filters
        let periodFrom = getters.getSelectedInvoicesPeriodFromFilter
        let periodTo = getters.getSelectedInvoicesPeriodToFilter
       
        // sorting options
        let options = getters.getInvoicesServerSideSortingOptions;

        let filterObj = {
            'search' :      getters.getInvoicesSearch,
            'type':         getters.getSelectedInvoicesTypeFilter,
            'status' :      getters.getSelectedInvoicesStatusFilter,
            'periodFrom':   periodFrom,
            'periodTo':     periodTo
        }

        if(periodFrom === null && periodTo === null) {
            filterObj['periodDate'] = []
        } else {
            filterObj['periodDate'] = getters.getSelectedInvoicesPeriodDateFilter
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)

        if(response === undefined || response.list.length === 0 || response.error === 1) {
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setInvoices', [])
        } else {
            commit('setInvoices', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)

    },

    // INVOICE RECIPIENT
    async fetchAutocompleteInvoicesRecipient({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setInvoicesRecipientOptions', response.list)
    },

    // DETAILS
    async fetchInvoicesDetails({ commit, getters, dispatch }, alvId) {
        commit('setIsLoading', true)
        if(alvId === undefined) alvId = getters.getInvoicesDetailsAlvId
        let values

        if(alvId === 'new') {
            values = JSON.parse(JSON.stringify(getters.getDefaultNewInvoice))
            values['currency'] = getters.getSelectedCurrency
        }
        else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                values = {}
            }
            else {
                let apiMonth = response.statisticIn.month // from API
                let apiYear = response.statisticIn.year // from API
                if (apiMonth != null && apiYear != null) {
                    response.statisticIn = apiYear + "-" + apiMonth
                } else {
                    // set YEAR-MONTH string to null instead of [object]
                    response.statisticIn = null
                }
                values = response
            }
        }
        //TODO
        //If the user changes the language, numberformating is not reactive.
        if(values.conversionFactor !== null) values.conversionFactor = i18n.n(values.conversionFactor,'decimal8')

        commit('setInvoicesDetails', values)
        dispatch('fetchInvoicesInvoiceRows')

        if (getters.getInvoicesDetailsRecipient !== undefined && getters.getInvoicesDetailsRecipient !== null) {
            commit('setInvoicesRecipientOptions', [getters.getInvoicesDetailsRecipient])
            commit('setInvoicesDetailsRecipientFullAddress', getters.getInvoicesDetailsRecipientFullAddress)
        }

        commit('setIsLoading', false)
    },

    // SAVE
    async saveInvoicesForm({ commit, getters, dispatch }) {
        let alvId = getters.getInvoicesDetailsAlvId
        let metaData = getters.getInvoicesDetails
        let isNew = router.currentRoute.params.alvId === "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg),
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_ERP_INVOICES_SNACKBAR_INVOICE_SAVED')
            })
            // redirect for url now with ALVID
            if(isNew) {
                router.push( { name: 'InvoicesEdit', params: { alvId:  response.response.alvId } })
            }
            // refresh data
            await dispatch('fetchInvoicesDetails',  response.response.alvId)
        }
    },

    // ACTIONS
    async doInvoicesAction({ commit, dispatch }) {
        switch(state.selectedInvoicesAction) {
            case 'print':
                if(state.selectedInvoices.length > 0) {
                    dispatch('printInvoices')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'delete':
                if(state.selectedInvoices.length > 0) {
                    commit('setShowDeletionDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'export':
                if(state.selectedInvoices.length > 0) {
                    dispatch('exportInvoices')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'copy':
                dispatch('copyInvoices')
                break
            case 'createAccountStatement':
                if(state.selectedInvoices.length > 0) {
                    dispatch('createAccountStatement')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
                    commit('setShowSelectionRequiredDialog', true)
                }
        }
    },

    // DELETE
    async deleteSelectedInvoices({ commit, getters, dispatch }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedInvoices)
        if(response.error === -1) {
            for(let i = 0; i < getters.getSelectedInvoices.length; i++) {
                let index = getters.getInvoices.findIndex(invoices => invoices.alvId == getters.getSelectedInvoices[i])
                Vue.delete(getters.getInvoices, index)
            }
            commit('setSelectedInvoices', [])
            commit('setSelectedInvoicesAction', [])
            dispatch('fetchInvoices')
        }
    },

    // COPY
    // COPY Pricelists
    async copyInvoices({ commit, getters, dispatch}) {
        let queryParams = { "action": "copy" }
        let metaData = { "alvIds": getters.getSelectedInvoices }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            dispatch('fetchInvoices')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // FETCH INVOICES ROWS
    async fetchInvoicesInvoiceRows({ commit, getters }){
        let invoiceRowsFromDB = await getters.getInvoicesDetails.invoiceRows
        if(invoiceRowsFromDB === undefined) return null
        else {
            commit('setIsLoading', false)
            if(invoiceRowsFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setInvoicesInvoiceRows', invoiceRowsFromDB)
        }
    },

    // FETCH PRODUCT TITLES
    // called from BaseEditPageAutocomplete = dispatch('fetchAutocomplete'+this.context+this.field, input)
    // where input = searchstring
    async fetchAutocompleteInvoicesInvoiceRowsTitle({ commit, getters }, input) {
        // depends on type of Company and of selected Entry Type
        // Label Companies: label/tracks and label/releases
        // Publishing Companies: publishing/works, publishing/sheets and publishing/releases
        let recipient = getters.getInvoicesDetailsRecipient
        let parameters = "invoiceRecipientAlvId=" + recipient.alvId // send invoice recipient ALVID to auto-set price from the BE
        let searchContext = getters.getInvoicesInvoiceRowsTitleSearch
        let response = await api.getAutocompleteSearch(searchContext, input, parameters)
        commit('setInvoicesInvoiceRowsTitleOptions', response.list)
    },

    // DELETE Invoice rows
    deleteSelectedInvoicesInvoiceRows({ getters, commit }) {
        let id = getters.getSelectedInvoicesInvoiceRows[0] // only one id is passed
        let index = state.invoicesInvoiceRows.findIndex(split => split.id == id)

        let numberOfRows = getters.getInvoicesInvoiceRows.length
        Vue.delete(state.invoicesInvoiceRows, index)
        let newNumberOfRows = getters.getInvoicesInvoiceRows.length
        commit("setSelectedInvoicesInvoiceRows", [])

        if(numberOfRows > newNumberOfRows) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedInvoicesInvoiceRows', []) // TODO_PT: seems double?
        if(newNumberOfRows === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    async fetchPriceForInvoiceEditPanel({commit, getters}, input) {
        return api.getPriceForReleaseAndCustomer(input.releaseId, input.invoiceId);
    },

    // ACTION: Print Invoice
    async printInvoices({ getters, commit }) {
        let metaData = { "alvIds": getters.getSelectedInvoices }
        let queryParams = { "action": "printPdf" }
        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response === 1 || response == undefined || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })
        } else {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
    },
    // ACTION: Export invoices
    async exportInvoices({ getters, commit }) {
        let queryParams = { "action" : "export" }
        let metaData = { "alvIds": getters.getSelectedInvoices }

        let actionResponse = await api.triggerAction(DIR, metaData, queryParams)
        if(actionResponse.error === 1 || actionResponse === undefined) {
            let errorMsg = actionResponse.response.errorMsg
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
            })
        } else {
            api.getFileFromALV(actionResponse.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
    },
    // Action: Create Account Statement
    async createAccountStatement({ getters, commit }) {
        let queryParams = { "action": "createAccountStatement"}
        let metaData = { "alvIds": getters.getSelectedInvoices }

        let actionResponse = await api.triggerAction(DIR, metaData, queryParams)
        if(actionResponse.error === 1 || actionResponse === undefined) {
            let errorMsg = actionResponse.response.errorMsg
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
            })
        } else {
            api.getFileFromALV(actionResponse.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
    },

    // Export unpaid invoices
    async invoicesAccountOverview({ commit }) {
        let metaData = { "alvIds": [] }
        let queryParams = { "action": "unpaidInvoices" }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response === undefined || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })
        } else {
            await api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
        commit("setSelectedFileReport",[])
    },

    async doGemaAuditReport({getters,commit}){
        commit("setIsLoading",true)

        // check for set filters
        let periodFrom = getters.getSelectedInvoicesPeriodFromFilter
        let periodTo = getters.getSelectedInvoicesPeriodToFilter

        let queryParams = { "action": 'gemaAuditReport' }
        let  metaData  = {
            'search' :      getters.getInvoicesSearch,
            'type':         getters.getSelectedInvoicesTypeFilter,
            'status' :      getters.getSelectedInvoicesStatusFilter,
            'periodFrom':   periodFrom,
            'periodTo':     periodTo
        }

        if(periodFrom === null && periodTo === null) {
            metaData['periodDate'] = []
        } else {
            metaData['periodDate'] = getters.getSelectedInvoicesPeriodDateFilter
        }

        let paramsString = this._vm.$alvPlugin.createApiPostFilterString(metaData)

        let response = await api.triggerAction(DIR, paramsString, queryParams)

        if(response.error === -1) {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })

        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL')
            })
        }
        commit("setIsLoading",false)
        commit("setSelectedFileReport",[])
    }
}

export default {
    state, getters, actions, mutations
}
